import type { EnrollmentEsConversionRow } from "./enrollmentTypes";
import { ErrorState, EsConversionCharts, LoadingState, SectionDivider } from "./enrollmentUi";

export function EnrollmentEsConversionTab(props: {
  analysisDate: string;
  error: string;
  loading: boolean;
  rows: EnrollmentEsConversionRow[];
}) {
  return (
    <div className="flex flex-col gap-4">
      <SectionDivider label="Last 4 Monday–Sunday weeks" />
      {props.loading ? (
        <LoadingState />
      ) : props.error ? (
        <ErrorState message={props.error} />
      ) : (
        <EsConversionCharts rows={props.rows} analysisDate={props.analysisDate} />
      )}
    </div>
  );
}
